export const NOTIFICATION_DISMISS = "NOTIFICATION_DIMISS";
export const NOTIFICATION_APPEND_MODAL = "NOTIFICATION_APPEND_MODAL";
export const NOTIFICATION_APPEND_TOAST = "NOTIFICATION_APPEND_TOAST";
export const NOTIFICATION_TYPE_MODAL = "MODAL";
export const NOTIFICATION_TYPE_TOAST = "TOAST";
